import React from 'react'

const Graficas = () => {
  return (
    <div className='container-fluid d-flex justify-content-center pb-5 border-bottom border-3'>
      <div className='container p-0 mt-3'>
        <div className='container-lg p-0'>
          <div className='py-3'>
            <p className='short-title font-semibold text-premium-blue mt-4'>Gráficas</p>
          </div>
          <div className='row mt-3 row-gap-3 text-premium-blue'>
            <div className='col-12 col-md-6 d-flex justify-content-center'>
              Lalo
            </div>
            <div className='col-12 col-md-6 d-flex justify-content-center'>
              Lalo
            </div>
          </div>
          <div className='row mt-3 row-gap-3 text-premium-blue'>
            <div className='col-12 col-md-6 d-flex justify-content-center'>
              Lalo
            </div>
            <div className='col-12 col-md-6 d-flex justify-content-center'>
              Lalo
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Graficas